import { Controller } from "@hotwired/stimulus"

// Contrôleur Stimulus pour la sélection multiple dans les tables
export default class extends Controller {
  static targets = ["row", "selectAll", "selectedCount", "bulkActions"]

  connect() {
    this.updateUI()
  }

  // Toggle toutes les checkboxes
  toggleAll(event) {
    const isChecked = event.target.checked

    this.rowTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })

    this.updateUI()
  }

  // Gérer le changement d'une checkbox individuelle
  rowChanged() {
    // Mettre à jour la checkbox "select all"
    if (this.hasSelectAllTarget) {
      const allChecked = this.rowTargets.every(cb => cb.checked)
      const someChecked = this.rowTargets.some(cb => cb.checked)

      this.selectAllTarget.checked = allChecked
      this.selectAllTarget.indeterminate = someChecked && !allChecked
    }

    this.updateUI()
  }

  // Mettre à jour l'interface en fonction de la sélection
  updateUI() {
    const selectedCount = this.getSelectedCount()

    // Mettre à jour le compteur
    if (this.hasSelectedCountTarget) {
      if (selectedCount > 0) {
        this.selectedCountTarget.textContent = `${selectedCount} sélectionné${selectedCount > 1 ? 's' : ''}`
        this.selectedCountTarget.classList.remove("hidden")
      } else {
        this.selectedCountTarget.classList.add("hidden")
      }
    }

    // Afficher/masquer les actions en masse
    if (this.hasBulkActionsTarget) {
      if (selectedCount > 0) {
        this.bulkActionsTarget.classList.remove("hidden")
      } else {
        this.bulkActionsTarget.classList.add("hidden")
      }
    }

    // Mettre en surbrillance les lignes sélectionnées
    this.highlightSelectedRows()
  }

  // Obtenir le nombre d'éléments sélectionnés
  getSelectedCount() {
    return this.rowTargets.filter(cb => cb.checked).length
  }

  // Obtenir les IDs des éléments sélectionnés
  getSelectedIds() {
    return this.rowTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }

  // Mettre en surbrillance les lignes sélectionnées
  highlightSelectedRows() {
    this.rowTargets.forEach(checkbox => {
      const row = checkbox.closest("tr")
      if (row) {
        if (checkbox.checked) {
          row.classList.add("bg-indigo-50")
          row.classList.remove("hover:bg-gray-50")
        } else {
          row.classList.remove("bg-indigo-50")
          row.classList.add("hover:bg-gray-50")
        }
      }
    })
  }

  // Actions en masse
  deleteSelected(event) {
    event.preventDefault()

    const selectedIds = this.getSelectedIds()
    const count = selectedIds.length

    if (count === 0) {
      return
    }

    const message = `Êtes-vous sûr de vouloir supprimer ${count} élément${count > 1 ? 's' : ''} ?`

    if (confirm(message)) {
      // Envoyer la requête de suppression
      this.performBulkAction("delete", selectedIds)
    }
  }

  exportSelected(event) {
    event.preventDefault()

    const selectedIds = this.getSelectedIds()

    if (selectedIds.length === 0) {
      alert("Veuillez sélectionner au moins un élément à exporter")
      return
    }

    this.performBulkAction("export", selectedIds)
  }

  // Effectuer une action en masse
  performBulkAction(action, ids) {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.data.get(`${action}Url`)
    form.style.display = "none"

    // Ajouter le token CSRF
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const csrfInput = document.createElement("input")
    csrfInput.type = "hidden"
    csrfInput.name = "authenticity_token"
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    // Ajouter les IDs
    ids.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "ids[]"
      input.value = id
      form.appendChild(input)
    })

    // Ajouter l'action
    const actionInput = document.createElement("input")
    actionInput.type = "hidden"
    actionInput.name = "bulk_action"
    actionInput.value = action
    form.appendChild(actionInput)

    document.body.appendChild(form)
    form.submit()
  }

  // Sélectionner une plage avec Shift
  handleShiftSelect(event) {
    if (!event.shiftKey) {
      this.lastCheckedIndex = this.rowTargets.indexOf(event.target)
      return
    }

    const currentIndex = this.rowTargets.indexOf(event.target)
    const start = Math.min(this.lastCheckedIndex || 0, currentIndex)
    const end = Math.max(this.lastCheckedIndex || 0, currentIndex)

    for (let i = start; i <= end; i++) {
      this.rowTargets[i].checked = event.target.checked
    }

    this.updateUI()
  }
}